// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpPicker } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
/**
 * @alpha
 */
export const Picker = wrap(jpPicker(), {
    events: {
        onChange: 'change',
        onInput: 'input'
    }
});
// @ts-expect-error unknown property
Picker.displayName = 'Jupyter.Picker';
